export const CREATE_DAEMON = "CREATE_DAEMON";
export const CREATE_DAEMON_SUCCESS = "CREATE_DAEMON_SUCCESS";
export const CREATE_DAEMON_FAIL = "CREATE_DAEMON_FAIL";

export const REFRESH_DAEMON_ACCESS_TOKEN = "REFRESH_DAEMON_ACCESS_TOKEN";
export const REFRESH_DAEMON_ACCESS_TOKEN_SUCCESS = "REFRESH_DAEMON_ACCESS_TOKEN_SUCCESS";
export const REFRESH_DAEMON_ACCESS_TOKEN_FAIL = "REFRESH_DAEMON_ACCESS_TOKEN_FAIL";

export const GET_ALL_DAEMONS = "GET_ALL_DAEMONS";
export const GET_ALL_DAEMONS_SUCCESS = "GET_ALL_DAEMONS_SUCCESS";
export const GET_ALL_DAEMONS_FAIL = "GET_ALL_DAEMONS_FAIL";

export const GET_EXECUTE_RESULTS = "GET_EXECUTE_RESULTS";
export const GET_EXECUTE_RESULTS_SUCCESS = "GET_EXECUTE_RESULTS_SUCCESS";
export const GET_EXECUTE_RESULTS_FAIL = "GET_EXECUTE_RESULTS_FAIL";

export const GET_LAMBDAS = "GET_LAMBDAS";
export const GET_LAMBDAS_SUCCESS = "GET_LAMBDAS_SUCCESS";
export const GET_LAMBDAS_FAIL = "GET_LAMBDAS_FAIL";

export const DEPLOY_LAMBDA = "DEPLOY_LAMBDA"
export const DEPLOY_LAMBDA_SUCCESS = "DEPLOY_LAMBDA_SUCCESS"
export const DEPLOY_LAMBDA_FAIL = "DEPLOY_LAMBDA_FAIL"

export const DEPLOYED_LAMBDA_DETAILS = "DEPLOYED_LAMBDA_DETAILS"
export const DEPLOYED_LAMBDA_DETAILS_SUCCESS = "DEPLOYED_LAMBDA_DETAILS_SUCCESS"
export const DEPLOYED_LAMBDA_DETAILS_FAIL = "DEPLOYED_LAMBDA_DETAILS_FAIL"


export const ADD_RUNBOOK_SCRIPT = "ADD_RUNBOOK_SCRIPT";
export const ADD_RUNBOOK_SCRIPT_SUCCESS = "ADD_RUNBOOK_SCRIPT_SUCCESS"
export const ADD_RUNBOOK_SCRIPT_FAIL = "ADD_RUNBOOK_SCRIPT_FAIL"

export const GET_RUNBOOK_SCRIPTS = "GET_RUNBOOK_SCRIPTS"
export const GET_RUNBOOK_SCRIPTS_SUCCESS = "GET_RUNBOOK_SCRIPTS_SUCCESS"
export const GET_RUNBOOK_SCRIPTS_FAIL = "GET_RUNBOOK_SCRIPTS_FAIL"

export const DEPLOY_RUNBOOK_SCRIPT = "DEPLOY_RUNBOOK_SCRIPT"
export const DEPLOY_RUNBOOK_SCRIPT_SUCCESS = "DEPLOY_RUNBOOK_SCRIPT_SUCCESS"
export const DEPLOY_RUNBOOK_SCRIPT_FAIL = "DEPLOY_RUNBOOK_SCRIPT_FAIL"

export const EDIT_RUNBOOK_SCRIPT = "EDIT_RUNBOOK_SCRIPT";
export const EDIT_RUNBOOK_SCRIPT_SUCCESS = "EDIT_RUNBOOK_SCRIPT_SUCCESS";
export const EDIT_RUNBOOK_SCRIPT_FAIL = "EDIT_RUNBOOK_SCRIPT_FAIL";

export const GET_ALERTS_BASED_ON_RESOURCE = "GET_ALERTS_BASED_ON_RESOURCE_NAME"
export const GET_ALERTS_BASED_ON_RESOURCE_SUCCESS = "GET_ALERTS_BASED_ON_RESOURCE_NAME_SUCCESS"
export const GET_ALERTS_BASED_ON_RESOURCE_FAIL = "GET_ALERTS_BASED_ON_RESOURCE_NAME_FAIL"

export const MAP_ALERT_TO_LAMBDA = "MAP_ALERT_TO_LAMBDA"
export const MAP_ALERT_TO_LAMBDA_SUCCESS = "MAP_ALERT_TO_LAMBDA_SUCCESS"
export const MAP_ALERT_TO_LAMBDA_FAIL = "MAP_ALERT_TO_LAMBDA_FAIL"

export const DISASSOCIATE_ALERT_FROM_LAMBDA = "DISASSOCIATE_ALERT_FROM_LAMBDA"
export const DISASSOCIATE_ALERT_FROM_LAMBDA_SUCCESS = "DISASSOCIATE_ALERT_FROM_LAMBDA_SUCCESS"
export const DISASSOCIATE_ALERT_FROM_LAMBDA_FAIL = "DISASSOCIATE_ALERT_FROM_LAMBDA_FAIL"

export const GET_MAPPED_LAMBDA_ALERTS = "GET_MAPPED_LAMBDA_ALERTS"
export const GET_MAPPED_LAMBDA_ALERTS_SUCCESS = "GET_MAPPED_LAMBDA_ALERTS_SUCCESS"
export const GET_MAPPED_LAMBDA_ALERTS_FAIL = "GET_MAPPED_LAMBDA_ALERTS_FAIL"

export const GET_DAEMON_DETAIL = "GET_DAEMON_DETAIL"
export const GET_DAEMON_DETAIL_SUCCESS = "GET_DAEMON_DETAIL_SUCCESS"
export const GET_DAEMON_DETAIL_FAIL = "GET_DAEMON_DETAIL_FAIL"

export const GET_ACCOUNT_LAMBDAS = "GET_ACCOUNT_LAMBDAS";
export const GET_ACCOUNT_LAMBDAS_SUCCESS = "GET_ACCOUNT_LAMBDAS_SUCCESS";
export const GET_ACCOUNT_LAMBDAS_FAIL = "GET_ACCOUNT_LAMBDAS_FAIL";

export const GET_AVAILABLE_ROLES = "GET_AVAILABLE_ROLES"
export const GET_AVAILABLE_ROLES_SUCCESS = "GET_AVAILABLE_ROLES_SUCCESS"
export const GET_AVAILABLE_ROLES_FAIL = "GET_AVAILABLE_ROLES_FAIL"

export const GET_ALL_TOKENS = "GET_ALL_TOKENS";
export const GET_ALL_TOKENS_SUCCESS = "GET_ALL_TOKENS_SUCCESS";
export const GET_ALL_TOKENS_FAIL = "GET_ALL_TOKENS_FAIL";

export const UPDATE_DAEMON_TOKEN = "UPDATE_DAEMON_TOKEN";
export const UPDATE_DAEMON_TOKEN_SUCCESS = "UPDATE_DAEMON_TOKEN_SUCCESS";
export const UPDATE_DAEMON_TOKEN_FAIL = "UPDATE_DAEMON_TOKEN_FAIL";